import { defHttp } from "../utils/http/axios";

const Api = {
    list : '/corpus/glossary/list',
    combineList : '/corpus/glossary/combinable/list',
    validate:'/corpus/glossary/action/validate',
    export:'/corpus/glossary/export',
    edit:'/corpus/glossary/edit',
    delete:'/corpus/glossary/delete',
    shareStateEdit:'/corpus/glossary/shareState/edit',
    state:'/corpus/glossary/list/state',
    detail:'/corpus/glossary/detail',
    shareState:'/corpus/glossary/shareState',
    match:'/corpus/glossary/match',
    count:'/corpus/glossary/user/count',
}
const FileApi = {
  upload : '/corpus/glossary/file/upload',
  preview : '/corpus/glossary/file/preview',
  list : '/corpus/glossary/file/list',
  info : '/corpus/glossary/file/info',
}
const MergeApi = {
  combine : '/corpus/glossary/merge/combine',
  add : '/corpus/glossary/merge/add',
}
const EntryApi = {
  list : '/corpus/glossary/entry/list',
  info : '/corpus/glossary/entry/info',
  edit : '/corpus/glossary/entry/edit',
  pair : '/corpus/glossary/entry/pair',
}


/**
 *  获取术语库列表
 * @param params
 */
export  function getList(data){
    return defHttp.post({url: Api.list, data});
}
/**获取单个术语库的字段值，用于编辑对话框/术语库详情 */
export  function getMetadata(params){
  return defHttp.get({url: Api.detail, params});
}
/**获取传入术语库的字段最新值 */
export  function getCurrentState(params) {
    return defHttp.post({url: Api.state, params});
}
/**修改单个术语库的权限 */
export  function changePermission(params) {
  return defHttp.post({url: Api.shareStateEdit, params});
}
/**获取单个术语库的权限 */
export  function getPermission(params){
  return defHttp.get({url: Api.shareState, params});
}
/**创建术语库 */
export  function create(params) {
  return defHttp.post({url: Api.edit, params});
}
/**查询可合并的术语库列表 */
export  function getCombinableList(params){
  return defHttp.get({url: Api.combineList, params});
}
/**导出记忆库 */
export function exportTb(params) {
  return defHttp.post({url: Api.export, params});
}
/**验证用户的操作，如删除/进入详情... */
export  function validateAction(params) {
  return defHttp.post({url: Api.validate, params}, { isTransformResponse: false });
}
/**删除术语库 */
export function deleteTb(params){
    return defHttp.delete({url: Api.delete, params},{joinParamsToUrl: true});
}
/**CAT 匹配术语库条目 */
export  function searchEntries(data) {
  return defHttp.postWithCancel({url: Api.match, data});
}
export  function getUserTBCount(params){
  return defHttp.get({url: Api.count, params});
}


/**开始合并 */
export  function combine(params) {
  return defHttp.post({url: MergeApi.combine, params});
}
/**合并术语库 */
export  function merge(params) {
  return defHttp.post({url: MergeApi.add, params});
}


/** 获得术语库id对应的文件们 */
export function getFiles(params) {
  return defHttp.get({url: FileApi.list, params});
}
/** 获取术语库文件*/
export function getFile(params) {
  return defHttp.get({url: FileApi.info, params});
}
/**上传术语库 */
export  function uploadFile(formData,options) {
  return defHttp.uploadCancellableFile({ url: FileApi.upload ,timeout:400000}, formData, {
      onUploadProgress(ev) {
        options.onUploadProgress(ev);
      },
    });
}
/**预览术语库 */
export  function preview(params) {
  return defHttp.post({url: FileApi.preview, params,timeout:400000}, { isTransformResponse: false });
}



/** 获取术语库单个条目的额外信息*/
export function getEntryInfo(params) {
  return defHttp.get({url: EntryApi.info, params});
}
/** 增/删/改术语库条目 */
export  function editEntries(params) {
  return defHttp.post({url: EntryApi.edit, params}, { isTransformResponse: false });
}
/** 编辑单个entry */
export  function editEntryPairTerm(params) {
  return defHttp.post({url: EntryApi.pair, params});
}
/**获取术语库的条目列表 */
export  function getBody(params) {
  return defHttp.post({url: EntryApi.list, params});
}



